import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  HandCoins,
  CreditCard,
  Bell,
  BarChart3,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useQuery } from "react-query";
import { api } from "@/lib/api";

const navItems = [
  { label: "Home", icon: LayoutDashboard, path: "/member/dashboard" },
  { label: "Savings", icon: HandCoins, path: "/member/contributions" },
  { label: "Loans", icon: CreditCard, path: "/member/loans" },
  { label: "Reports", icon: BarChart3, path: "/member/reports/dashboard" },
  { label: "Notifications", icon: Bell, path: "/member/notifications" },
];

export default function BottomNav() {
  const location = useLocation();

  const { data: unreadCount } = useQuery(
    ["notif-unread-count"],
    async () => {
      const { data } = await api.get("/notifications/my/unread-count");
      return data?.data?.unreadCount || 0;
    },
    { refetchInterval: 30000 }
  );

  const isActive = (path: string) => {
    if (path === "/member/loans") {
      return location.pathname.startsWith("/member/loans");
    }
    if (path === "/member/reports/dashboard") {
      return location.pathname.startsWith("/member/reports");
    }
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.05)] md:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map(({ label, icon: Icon, path }) => {
          const active = isActive(path);
          const isNotif = label === "Notifications";
          const count = (unreadCount as number) || 0;
          return (
            <NavLink
              key={path}
              to={path}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 w-16 py-1 rounded-lg transition-colors relative",
                active
                  ? "text-[#009A44]"
                  : "text-slate-400 hover:text-slate-600"
              )}
            >
              <div className="relative">
                <Icon className="h-5 w-5" />
                {isNotif && count > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 h-3.5 w-3.5 rounded-full bg-red-500 text-white text-[8px] font-bold flex items-center justify-center">
                    {count > 9 ? "9+" : count}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium leading-tight">
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
